import i18n from 'i18next'
import { observable, autorun, makeObservable } from 'mobx'
import * as R from 'ramda'

import Product from './model/Product'
import { sortByNameCaseInsensitive } from '../components/helpers'

class ProductEditStore {
    @observable productTypes = []

    defaultPortfolio = { value: '', label: 'View all' }

    sectorDetails = observable.map({
        sector: null,
        primary: null,
        secondary: null,
        ce: null,
    })

    showSector = observable.map({
        primary: false,
        secondary: false,
    })

    sectorOptions = observable.map({})

    gender = [
        {
            value: '',
            label: 'None',
        },
        {
            value: 'n',
            label: 'Neutral',
        },
        {
            value: 'm',
            label: 'Masculine',
        },
        {
            value: 'f',
            label: 'Feminine',
        },
        {
            value: 'p',
            label: 'Plural',
        },
    ]

    productScheduleCE = [
        {
            value: 'P',
            label: 'Annual / Periodic Events',
        },
        {
            value: '1',
            label: 'One off Events',
        },
        {
            value: 'R',
            label: 'Repeat Events',
        },
    ]

    productYears = [
        {
            value: 1,
            label: i18n.t('product_recurrence_annual'),
        },
        {
            value: 2,
            label: i18n.t('product_recurrence_every_2_yrs'),
        },
        {
            value: 3,
            label: i18n.t('product_recurrence_every_3_yrs'),
        },
        {
            value: 4,
            label: i18n.t('product_recurrence_every_4_yrs'),
        },
        {
            value: 99,
            label: i18n.t('product_recurrence_other'),
        },
    ]

    productYearRun = [
        {
            value: 1,
            label: i18n.t('product_yrs_run_launch'),
        },
        {
            value: 2,
            label: i18n.t('product_yrs_run_2'),
        },
        {
            value: 3,
            label: i18n.t('product_yrs_run_3'),
        },
        {
            value: 4,
            label: i18n.t('product_yrs_run_4'),
        },
        {
            value: 5,
            label: i18n.t('product_yrs_run_5'),
        },
        {
            value: 6,
            label: i18n.t('product_yrs_run_6'),
        },
        {
            value: 7,
            label: i18n.t('product_yrs_run_7'),
        },
        {
            value: 8,
            label: i18n.t('product_yrs_run_8'),
        },
        {
            value: 9,
            label: i18n.t('product_yrs_run_9'),
        },
        {
            value: 10,
            label: i18n.t('product_yrs_run_10_15'),
        },
        {
            value: 15,
            label: i18n.t('product_yrs_run_gt_15'),
        },
    ]

    productPubSub = [
        {
            value: 1,
            label: i18n.t('views.product.wizard.PU.form.pubsubscripoptions.options.free_publication'),
        },
        {
            value: 2,
            label: i18n.t('views.product.wizard.PU.form.pubsubscripoptions.options.paid_for_via_subscription'),
        },
        {
            value: 3,
            label: i18n.t('views.product.wizard.PU.form.pubsubscripoptions.options.paid_for_via_news_stand'),
        },
        {
            value: 4,
            label: i18n.t('views.product.wizard.PU.form.pubsubscripoptions.options.online_edition'),
        },
    ]

    productPubFrequency = [
        {
            value: 1,
            label: i18n.t('views.product.wizard.PU.form.pubfrequency.options.daily'),
        },
        {
            value: 2,
            label: i18n.t('views.product.wizard.PU.form.pubfrequency.options.weekly'),
        },
        {
            value: 3,
            label: i18n.t('views.product.wizard.PU.form.pubfrequency.options.monthly'),
        },
        {
            value: 4,
            label: i18n.t('views.product.wizard.PU.form.pubfrequency.options.bimonthly'),
        },
        {
            value: 5,
            label: i18n.t('views.product.wizard.PU.form.pubfrequency.options.quarterly'),
        },
        {
            value: 6,
            label: i18n.t('views.product.wizard.PU.form.pubfrequency.options.yearly'),
        },
        {
            value: 7,
            label: i18n.t('views.product.wizard.PU.form.pubfrequency.options.other'),
        },
    ]

    productVisAttraction = [
        {
            value: 1,
            label: i18n.t('views.product.wizard.VA.form.visattractiontype.options.zoo_animal_aquarium'),
        },
        {
            value: 2,
            label: i18n.t('views.product.wizard.VA.form.visattractiontype.options.theme_amusement_park'),
        },
        {
            value: 3,
            label: i18n.t('views.product.wizard.VA.form.visattractiontype.options.gallery'),
        },
        {
            value: 4,
            label: i18n.t('views.product.wizard.VA.form.visattractiontype.options.museum'),
        },
        {
            value: 5,
            label: i18n.t('views.product.wizard.VA.form.visattractiontype.options.viewing_tower_platform'),
        },
        {
            value: 6,
            label: i18n.t('views.product.wizard.VA.form.visattractiontype.options.historical_attraction'),
        },
        {
            value: 7,
            label: i18n.t('views.product.wizard.VA.form.visattractiontype.options.entertainment_tv_film'),
        },
        {
            value: 8,
            label: i18n.t('views.product.wizard.VA.form.visattractiontype.options.other'),
        },
    ]

    productVisAttTempPerm = [
        {
            value: 1,
            label: i18n.t('views.product.wizard.VA.form.visattrntemporperm.options.temporary'),
        },
        {
            value: 2,
            label: i18n.t('views.product.wizard.VA.form.visattrntemporperm.options.permanent'),
        },
    ]

    productVisAttSeasona = [
        {
            value: 1,
            label: i18n.t('views.product.wizard.VA.form.visattrnseasonal.options.open_all_year'),
        },
        {
            value: 2,
            label: i18n.t('views.product.wizard.VA.form.visattrnseasonal.options.seasonal'),
        },
    ]

    productVisAttrAge = [
        {
            value: 1,
            label: i18n.t('views.product.wizard.VA.form.visattrnage.options.less_than_1_yr'),
        },
        {
            value: 2,
            label: i18n.t('views.product.wizard.VA.form.visattrnage.options.1_to_2_yrs'),
        },
        {
            value: 3,
            label: i18n.t('views.product.wizard.VA.form.visattrnage.options.3_to_5_yrs'),
        },
        {
            value: 4,
            label: i18n.t('views.product.wizard.VA.form.visattrnage.options.6_to_10_yrs'),
        },
        {
            value: 5,
            label: i18n.t('views.product.wizard.VA.form.visattrnage.options.11_to_20_yrs'),
        },
        {
            value: 6,
            label: i18n.t('views.product.wizard.VA.form.visattrnage.options.more_than_20_yrs'),
        },
    ]

    statuses = [
        {
            value: 1,
            label: 'Created',
        },
        {
            value: 2,
            label: 'Active',
        },
        {
            value: 3,
            label: 'Archived',
        },
        {
            value: 4,
            label: 'Deleted',
        },
        {
            value: 5,
            label: 'Template',
        },
    ]

    productVisAttrStdTicketCost = [
        {
            value: 1,
            label: i18n.t('views.product.wizard.VA.form.visattrnstdticketcost.options.no_cost'),
        },
        {
            value: 2,
            label: i18n.t('views.product.wizard.VA.form.visattrnstdticketcost.options.less_than_5_gbp'),
        },
        {
            value: 3,
            label: i18n.t('views.product.wizard.VA.form.visattrnstdticketcost.options.5_to_9_99_gbp'),
        },
        {
            value: 4,
            label: i18n.t('views.product.wizard.VA.form.visattrnstdticketcost.options.10_to_19_99_gbp'),
        },
        {
            value: 5,
            label: i18n.t('views.product.wizard.VA.form.visattrnstdticketcost.options.20_to_29_99_gbp'),
        },
        {
            value: 6,
            label: i18n.t('views.product.wizard.VA.form.visattrnstdticketcost.options.30_gbp_or_more'),
        },
    ]

    taxonomies = []

    @observable level2Taxonomies = []

    level3Taxonomies = []

    @observable customCategories = []

    @observable showCustomCategories = false

    @observable stage = 0

    @observable mergeFieldOptions

    @observable availableTags = []

    @observable recordTags = []

    ceSectorVocabulary = 5

    showIsEventFree = false

    @observable formFields = []

    @observable formLoading = true

    productTypesOrderEV = ['Trade', 'Consumer', 'Conference', 'Virtual Event']

    @observable divisionId = null

    constructor(store) {
        makeObservable(this)
        this.appStore = store
        this.product = new Product({}, store)

        autorun(() => {
            if (this.formFields.length > 0) this.formLoading = false
        })
    }

    initProduct = async (productId, industryCode, surveyType, onExit) => {
        this.formLoading = true

        this.sectorDetails = observable.map({
            sector: null,
            primary: null,
            secondary: null,
            ce: null,
        })

        this.showSector = observable.map({
            primary: false,
            secondary: false,
        })

        this.sectorOptions = observable.map({})

        await this.initStore()

        const isEditing = productId !== 0

        let productDetails

        try {
            if (isEditing) {
                productDetails = await this.getProduct(productId, industryCode)

                const mergeFieldOptions = await this.getMergeFieldOptions(
                    productDetails[0].industry, productDetails[0].productType,
                )

                this.mergeFieldOptions = mergeFieldOptions

                this.invalidProduct = productDetails.length === 0

                if (this.invalidProduct) {
                    window.location = '/home/e/0105.1'
                    // this.appStore.addNotification(null, 'Invalid event', 'error')
                    return
                }
            }

            const details = isEditing
                ? productDetails[0]
                : { industry: industryCode }

            this.vocabularyId = (details.industry === 'CE' ? 3 : 1)

            this.product = new Product(details, this.appStore)

            if (surveyType === 'EM') {
                this.product.productType = 'CE3P'
                this.surveyType = surveyType
            }

            this.portfolios = this.allPortfolios.filter(
                ({ industry }) => industry === this.product.industry,
            )

            this.productTypes = R.sortBy(R.prop('label'))(this.allProductTypes
                .filter(({ industry }) => industry === this.product.industry))

            await Promise.all([
                // this.loadSectorOptions('primary', (this.vocabularyId), isEditing),
                this.loadCESectors(),
            ])

            if (isEditing) {
                const isCorporateEvent = productDetails[0].industry === 'CE'
                if (isCorporateEvent && R.hasPath(['additionalTaxonomies', this.ceSectorVocabulary])(this.product)) {
                    const { termId } = R.path(['additionalTaxonomies', this.ceSectorVocabulary])(this.product)
                    const sector = this.sectorOptions.get('ce').find(({ value }) => value === termId)
                    this.sectorDetails.set('ce', sector)
                }

                // commented unused primary & secondary sectors
                if (!isCorporateEvent && R.hasPath(['additionalTaxonomies', this.vocabularyId])(this.product)) {
                    const {
                        termId, parentId,
                    } = this.product.additionalTaxonomies[this.vocabularyId]
                    const primaryId = parentId || termId
                    const primary = this.sectorOptions.get('primary').find(({ value }) => value === primaryId)
                    this.sectorDetails.set('primary', primary)

                    if (parentId) {
                        await this.getProductLevelThree(parentId)

                        const secondary = this.sectorOptions.get('secondary').find(({ value }) => value === termId)

                        this.sectorDetails.set('secondary', secondary)
                        this.sectorDetails.set('sector', secondary.value)
                    } else {
                        this.sectorDetails.set('sector', primary.value)
                    }
                }
            }

            await this.getTags(productId)
            this.defineFormFields()
            this.formLoading = false
        } catch (error) {
            this.formLoading = true
            onExit()
            console.log('ProductEditStore initEdit error ', error)
        }
    }

    getTags = async (productId) => {
        const { divisionId, product } = this
        const { industry, productType, portfolioId } = product

        this.availableTags = await this.appStore.getAvailableTags({
            oid: 6,
            divisionId,
            portfolioId,
            industry,
            productType,
        })

        this.recordTags = await this.appStore.getRecordTags(6, productId)
    }

    initStore = async () => {
        const [portfolios, industries, taxonomies] = await Promise.all([
            this.getPortfolios(),
            this.getIndustries(),
            this.getTaxonomies(),
        ])

        this.industries = industries

        this.showSector.set('primary', true)
        this.sectorOptions.set('primary', taxonomies)

        const productTypes = await Promise.all(
            industries.map(this.getProductTypes),
        )

        this.allPortfolios = [this.defaultPortfolio].concat(
            portfolios.map(({
                portfolioId, name, industry, divisionId,
            }) => ({
                value: portfolioId,
                label: name,
                industry,
                divisionId,
            })).sort((a, b) => a.label.localeCompare(b.label)),
        )

        this.allProductTypes = industries.reduce((list, industry, index) => {
            const industryProductTypes = productTypes[index].map(({ code, name }) => ({
                value: code,
                label: name,
                selected: true,
                industry: industry.code,
                industryName: industry.name,
            }))
            return list.concat(industryProductTypes)
        }, [])

        this.productTypes = R.sortBy(R.prop('label'))(this.allProductTypes.map(({
            value, label, selected, industryName,
        }) => ({
            value,
            label: `${industryName} - ${label}`,
            selected,
        })))
    }

    setTag = ({ name, value }) => {
        console.log('setTag', name, value)
        this.recordTags[name] = value
    }

    saveTags = async (recordId) => {
        const { appStore } = this
        try {
            appStore.saveTags(recordId, 6, this.availableTags, this.recordTags)
        } catch (e) {
            console.error(e)
        }
    }

    getCustomTerms = async (keepValues = false) => {
        const { product, appStore } = this
        const { industry, productType } = product
        const customCategory = await appStore.http.get(`/category/product/0?industry=${industry}&productType=${productType}`)
        this.customCategories = customCategory.map((c) => ({
            description: c.description,
            vocabularyId: c.vocabularyId,
            terms: c.terms.map(({ name, termId }) => ({
                value: termId,
                label: name,
            })),
        }))
        const vocabularies = this.customCategories
            .map(({ vocabularyId }) => vocabularyId)
            .concat(this.vocabularyId)

        if (!keepValues) {
            Object.keys(product.additionalTaxonomies).forEach((key) => {
                if (!vocabularies.includes(parseInt(key, 10))) {
                    Reflect.deleteProperty(product.additionalTaxonomies, key)
                }
            })
        }
        this.showCustomCategories = this.customCategories.length > 0
    }

    getPortfolios = async () => this.appStore.http.get('/portfolio')

    getProductTypes = ({ code }) => this.appStore.http.get(`/producttype/${code}`)

    getIndustries = () => this.appStore.http.get('/client/industry')

    getTaxonomies = async () => {
        const taxonomies = await this.appStore.http.get('/taxonomy/vocabulary/1')
        return sortByNameCaseInsensitive(taxonomies.map((({ label, termId }) => ({
            label,
            value: termId,
        }))))
    }

    getProduct = async (productId, industry) => {
        const { appStore } = this
        const { http } = appStore

        let productDetails = [{ industry }]
        if (parseInt(productId, 10) !== 0) {
            productDetails = await http.get(`/product/${productId}`)
        }

        return productDetails
    }

    getMergeFieldOptions = async (industry, productType) => {
        const { appStore } = this
        if (!productType) return []
        return appStore.http.get(`/mergefield/6/${industry}/${this.divisionId}/${this.product.portfolioId}/${productType}`)
    }

    getDefaultMergeFieldValue = (mergefieldId) => {
        const { appStore, product } = this
        return R.pathOr('', ['mergefields', [mergefieldId], [appStore.langcode]], product)
    }

    changeMergeFields = (mergeFieldId, value) => {
        const { appStore } = this
        const { langcode } = appStore
        const { mergefields } = this.product
        this.product.mergefields = { ...mergefields, [mergeFieldId]: { [langcode]: value } }
    }

    setSector = (obj) => {
        this.sectorDetails.set('sector', obj.value)
        this.product.additionalTaxonomies[this.vocabularyId] = { termId: obj.value }
    }

    loadCESectors = async () => {
        const { appStore } = this
        const { http } = appStore

        const ceSectors = await http.get('/taxonomy/vocabulary/5')
        const ceOptions = ceSectors.map(({ termId, label }) => ({
            label,
            value: termId,
        }))

        this.sectorOptions.set('ce', ceOptions)
    }

    // loadSectorOptions = async (target, key, keepValues = false) => {
    //     const { appStore, product } = this
    //     const { http } = appStore

    //     const levels = ['primary', 'secondary', 'tertiary']
    //     const levelIndex = levels.indexOf(target)

    //     let url = target === 'primary'
    //         ? `/taxonomy/vocabulary/${key}`
    //         : `/taxonomy/parent/${key}`
    //     console.log(`loadSectorOptions ${target}, ${product.industry}`)
    //     if (product.industry === 'CE' && target === 'primary') {
    //         if (!product.productType) {
    //             return
    //         }
    //         url = `/taxonomy/vocabulary/${key}/code/${product.productType}`
    //     }

    //     const sectorOptions = await http.get(url)

    //     const options = sectorOptions.map(({ termId, label }) => ({
    //         label,
    //         value: termId,
    //     }))

    //     console.log(`set ${target} -> ${JSON.stringify(options)}`)
    //     // allSectorOptions[target] = options
    //     this.sectorOptions.set(target, options)
    //     for (let i = 2; i > levelIndex; i--) {
    //         this.sectorOptions.delete(levels[i])
    //     }
    //     for (let i = 2; i >= levelIndex; i--) {
    //         this.sectorDetails.set(levels[i], null)
    //     }
    //     this.sectorDetails.set('sector', null)
    //     if (!keepValues) {
    //         Reflect.deleteProperty(this.product.additionalTaxonomies, this.vocabularyId)
    //     }
    //     this.showSector.set(target, options.length > 0)
    // }

    // loadSecondary = async (parent) => {
    //     await this.loadSectorOptions('secondary', parent)
    //     const secondary = this.sectorOptions.get('secondary').length > 0
    //     return secondary
    // }

    // loadTertiary = async (parent) => {
    //     await this.loadSectorOptions('tertiary', parent)
    //     const tertiary = this.sectorOptions.get('tertiary').length > 0
    //     return tertiary
    // }

    clearProductLevelThree = () => {
        this.sectorDetails.set('secondary', null)
        this.sectorOptions.set('secondary', null)
    }

    clearProductLevelTwo = () => {
        this.sectorDetails.set('primary', null)
        this.sectorOptions.set('primary', null)
    }

    getProductLevelTwo = async (productType) => {
        const { appStore } = this
        const { http } = appStore

        const productPrimaryOption = await http.get(`/taxonomy/vocabulary/3/code/${productType}`)
        const options = sortByNameCaseInsensitive(
            productPrimaryOption.map(({ termId, label }) => ({
                label,
                value: termId,
            })),
        )

        this.showSector.set('secondary', false)
        this.clearProductLevelThree()
        this.clearProductLevelTwo()
        this.sectorOptions.set('primary', options)
        this.showSector.set('primary', options.length > 0)
    }

    getProductLevelThree = async (termId) => {
        const { appStore } = this
        const { http } = appStore

        const productSecondaryOptions = await http.get(`/taxonomy/parent/${termId}`)
        const options = sortByNameCaseInsensitive(
            productSecondaryOptions.map(({ termId, label }) => ({
                label,
                value: termId,
            })),
        )

        console.log('>> prod level three options', options)
        this.clearProductLevelThree()
        this.sectorOptions.set('secondary', options)
        this.showSector.set('secondary', options.length > 0)
    }

    // set form fields
    setProductTypeField = async ({ name, value }) => {
        const showIsEventFree = ['CO', 'VI'].includes(value)

        const mergeFieldOptions = await this.getMergeFieldOptions(this.product.industry, value)
        this.mergeFieldOptions = mergeFieldOptions

        this.availableTags = await this.appStore.getAvailableTags({
            oid: 6,
            industry: this.product.industry,
            productType: value,
        })

        if (!showIsEventFree) {
            Reflect.deleteProperty(this.product, 'isEventFree')
        }
        this.getCustomTerms()
        // if (this.product.industry === 'CE') {
        //     this.loadSectorOptions('primary', this.vocabularyId)
        // }
        this.showIsEventFree = showIsEventFree
    }

    setSectorField = ({ name, value, label }) => {
        this.sectorDetails.set(name, {
            value,
            label,
        })

        if (name === 'ce') {
            this.product.additionalTaxonomies[this.ceSectorVocabulary] = { termId: value }
        } else if (name === 'primary') {
            this.product.additionalTaxonomies[this.vocabularyId] = { termId: value }
        } else if (name === 'secondary') {
            this.product.additionalTaxonomies[this.vocabularyId] = { termId: value }
        }
    }

    // setSectorField = async ({ name, value, label }) => {
    //     const { industry } = this.product
    //     this.sectorDetails.set(name, {
    //         value,
    //         label,
    //     })

    //     if (name === 'primary') {
    //         this.sectorDetails.set('secondary', null)
    //     } else if (name === 'secondary') {
    //         this.sectorDetails.set('tertiary', null)
    //     }

    //     let show = false
    //     if (name === 'primary') {
    //         show = await this.loadSecondary(value)
    //     } else if (name === 'secondary' && industry === 'CE') {
    //         show = await this.loadTertiary(value)
    //     }

    //     if (!show) {
    //         this.setSector({
    //             name,
    //             value,
    //         })
    //     }
    // }

    setField = async ({
        name, value, label, divisionId,
    }, productId) => {
        if (name === 'productType') {
            this.product[name] = value
            await this.setProductTypeField({ name, value })
            if (this.product.industry === 'CE') await this.getProductLevelTwo(value)
        } else if (name === 'gender') {
            this.product.privilegedFields[name] = value
        } else if (name.startsWith('sector-')) {
            const sectorName = name.split('-')[1]
            this.setSectorField({ name: sectorName, value, label })
            if (sectorName === 'primary') await this.getProductLevelThree(value)
        } else if (name.startsWith('privilegedFields-')) {
            const privilegeName = name.split('-')[1]
            this.product.privilegedFields[privilegeName] = value
        } else if (name.startsWith('customCategory-')) {
            const vocabularyId = name.split('-')[1]
            this.product.additionalTaxonomies[vocabularyId] = { termId: value }
        } else if (name.startsWith('params-')) {
            const paramsName = name.split('-')[1]
            this.product.params[paramsName] = value
        } else if (name === 'portfolioId') {
            this.product[name] = value
            this.divisionId = divisionId
            this.getTags(productId)
        } else this.product[name] = value

        this.defineFormFields()
    }

    ceValidate = (name, validate) => (validate({
        value: this.sectorDetails.get('ce'),
        name,
    }, true))

    defineParamsFields = () => {
        const { industry, params } = this.product

        return [
            {
                type: 'select',
                name: 'params-scheduleValue',
                path: ['params', 'scheduleValue'],
                label: i18n.t('views.product.wizard.EV.form.schedulevalue.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.scheduleValue,
                options: this.productYears,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.EV.form.schedulevalue.validation.required'),
                isHide: industry !== 'EV',
            },
            {
                type: 'select',
                name: 'params-yearRun',
                path: ['params', 'yearRun'],
                label: i18n.t('views.product.wizard.EV.form.yearrun.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.yearRun,
                options: this.productYearRun,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.EV.form.yearrun.validation.required'),
                isHide: industry !== 'EV',
            },
            {
                type: 'select',
                name: 'params-schedule',
                path: ['params', 'schedule'],
                label: i18n.t('views.product.wizard.EV.form.schedulevalue.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.schedule,
                options: this.productScheduleCE,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.EV.form.schedulevalue.validation.required'),
                isHide: industry !== 'CE',
            },
            {
                type: 'select',
                name: 'params-pubFrequency',
                path: ['params', 'pubFrequency'],
                label: i18n.t('views.product.wizard.PU.form.pubfrequency.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.pubFrequency,
                options: this.productPubFrequency,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.PU.form.pubfrequency.validation.required'),
                isHide: industry !== 'PU',
            },
            {
                type: 'checkbox-group',
                name: 'params-pubSubscripOptions',
                path: ['params', 'pubSubscripOptions'],
                label: i18n.t('views.product.wizard.PU.form.pubsubscripoptions.label'),
                options: this.productPubSub,
                value: params?.pubSubscripOptions,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.PU.form.pubsubscripoptions.validation.required'),
                isHide: industry !== 'PU',
            },
            {
                type: 'input',
                name: 'params-pubPrintCirc',
                path: ['params', 'pubPrintCirc'],
                label: i18n.t('views.product.wizard.PU.form.pubprintcirc.label'),
                placeholder: i18n.t('form.input.placeholder', 'Enter here'),
                defaultValue: params?.pubPrintCirc,
                isMandatory: true,
                emptyError: i18n.t('views.product.wizard.PU.form.pubprintcirc.validation.required'),
                isHide: industry !== 'PU',
            },
            {
                type: 'input',
                name: 'params-pubOnLineCirc',
                path: ['params', 'pubOnLineCirc'],
                label: i18n.t('views.product.wizard.PU.form.pubonlinecirc.label'),
                placeholder: i18n.t('form.input.placeholder', 'Enter here'),
                defaultValue: params?.pubOnLineCirc,
                isMandatory: true,
                emptyError: i18n.t('views.product.wizard.PU.form.pubonlinecirc.validation.required'),
                isHide: industry !== 'PU',
            },
            {
                type: 'select',
                name: 'params-visattractiontype',
                path: ['params', 'visattractiontype'],
                label: i18n.t('views.product.wizard.VA.form.visattractiontype.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.visattractiontype,
                options: this.productVisAttraction,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.VA.form.visattractiontype.validation.required'),
                isHide: industry !== 'VA',
            },
            {
                type: 'input',
                name: 'params-visattrncountry',
                path: ['params', 'visattrncountry'],
                label: i18n.t('views.product.wizard.VA.form.visattrncountry.label'),
                placeholder: i18n.t('form.input.placeholder', 'Enter here'),
                defaultValue: params?.visattrncountry,
                isMandatory: true,
                emptyError: i18n.t('views.product.wizard.VA.form.visattrncountry.validation.required'),
                isHide: industry !== 'VA',
            },
            {
                type: 'input',
                name: 'params-visattrncity',
                path: ['params', 'visattrncity'],
                label: i18n.t('views.product.wizard.VA.form.visattrncity.label'),
                placeholder: i18n.t('form.input.placeholder', 'Enter here'),
                defaultValue: params?.visattrncity,
                isMandatory: true,
                emptyError: i18n.t('views.product.wizard.VA.form.visattrncity.validation.required'),
                isHide: industry !== 'VA',
            },
            {
                type: 'select',
                name: 'params-visattrntemporperm',
                path: ['params', 'visattrntemporperm'],
                label: i18n.t('views.product.wizard.VA.form.visattrntemporperm.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.visattrntemporperm,
                options: this.productVisAttTempPerm,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.VA.form.visattrntemporperm.validation.required'),
                isHide: industry !== 'VA',
            },
            {
                type: 'select',
                name: 'params-visattrnseasonal',
                path: ['params', 'visattrnseasonal'],
                label: i18n.t('views.product.wizard.VA.form.visattrnseasonal.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.visattrnseasonal,
                options: this.productVisAttSeasona,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.VA.form.visattrnseasonal.validation.required'),
                isHide: industry !== 'VA',
            },
            {
                type: 'select',
                name: 'params-visattrnstdticketcost',
                path: ['params', 'visattrnstdticketcost'],
                label: i18n.t('views.product.wizard.VA.form.visattrnstdticketcost.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.visattrnstdticketcost,
                options: this.productVisAttrStdTicketCost,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.VA.form.visattrnstdticketcost.validation.required'),
                isHide: industry !== 'VA',
            },
            {
                type: 'select',
                name: 'params-visattrnage',
                path: ['params', 'visattrnage'],
                label: i18n.t('views.product.wizard.VA.form.visattrnage.label'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: params?.visattrnage,
                options: this.productVisAttrAge,
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.VA.form.visattrnage.validation.required'),
                isHide: industry !== 'VA',
            },
        ]
    }

    defineCustomerCategoryFields = () => {
        const {
            appStore, product, customCategories, showCustomCategories,
        } = this
        const defaultValues = {}

        customCategories.forEach(({ vocabularyId, terms }) => {
            if (R.hasPath(['additionalTaxonomies', vocabularyId])(product)) {
                const termId = R.path(['additionalTaxonomies', vocabularyId, 'termId'])(product)
                defaultValues[vocabularyId] = termId
            }
        })

        return customCategories.map((cc) => (
            {
                type: 'select',
                name: `customCategory-${cc.vocabularyId}`,
                label: cc.description,
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: defaultValues[cc.vocabularyId],
                options: cc.terms,
                isHide: !(appStore.isMasterSuper() && showCustomCategories),
            }
        ))
    }

    defineFormFields = () => {
        const {
            appStore, product, productTypes, productTypesOrderEV,
        } = this
        const { industry } = this.product
        const isVENU = industry === 'VENU'

        this.formFields = [
            {
                type: 'input',
                name: 'name',
                label: i18n.t(`views.survey.wizard.${industry}.stage.1.event.add`),
                placeholder: i18n.t('form.input.placeholder', 'Enter here'),
                defaultValue: product.name,
                isMandatory: true,
                emptyError: i18n.t(`views.product.wizard.${industry}.form.name.validation.required`),
            },
            {
                type: 'input',
                name: 'edition',
                label: i18n.t(`views.product.wizard.${industry}.form.product_edition.label`),
                placeholder: i18n.t('views.product.wizard.placeholderText.edition', 'e.g. London'),
                defaultValue: product.edition,
                isHide: ['VA'].includes(product.industry),
                tooltipText: i18n.t(`views.product.wizard.tooltipText.edition${isVENU ? '.VENU' : ''}`),
            },
            {
                type: 'select',
                name: 'gender',
                path: ['privilegedFields', 'gender'],
                label: i18n.t('views.survey.wizard.placeholderText.gender', 'Enter gender'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: product.privilegedFields.gender,
                options: this.gender,
                isMandatory: true,
                errorMessage: i18n.t('product.form.error.gender'),
                isHide: !appStore.isExploriAdmin() || industry === 'VENU',
                tooltipText: i18n.t('views.product.wizard.tooltipText.gender'),
            },
            {
                type: 'select',
                name: 'portfolioId',
                label: i18n.t(`views.product.wizard.${industry}.form.portfolio.label`),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: product.portfolioId,
                options: this.portfolios,
                isMandatory: true,
                errorMessage: i18n.t('product.form.error.portfolio'),
                isHide: this.portfolios.length === 0,
            },
            {
                type: 'select',
                name: 'productType',
                label: i18n.t(`views.product.wizard.${industry}.form.product_type.label`),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: product.productType,
                options: industry === 'EV' ? productTypes.sort((a, b) => productTypesOrderEV.indexOf(a.label) - productTypesOrderEV.indexOf(b.label)) : productTypes,
                isMandatory: true,
                errorMessage: i18n.t('product.form.error.productType'),
                isHide: ['VA'].includes(product.industry) || ['EM'].includes(this.surveyType),
            },
            ...this.defineParamsFields(),
            {
                type: 'select',
                name: 'sector-ce',
                path: ['additionalTaxonomies', this.ceSectorVocabulary, 'termId'],
                label: i18n.t('views.survey.wizard.EV.stage.1.event.sectors.level1'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                value: this.sectorDetails.get('ce'),
                options: this.sectorOptions.get('ce'),
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.EV.form.sector.validation.required'),
                isHide: !['CE'].includes(industry),
            },
            {
                type: 'select',
                name: 'sector-primary',
                path: ['additionalTaxonomies', this.vocabularyId, 'termId'],
                label: i18n.t(`views.survey.wizard.${industry}.stage.1.event.sectors.level1`),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                value: this.sectorDetails.get('primary'),
                options: this.sectorOptions.get('primary'),
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.EV.form.sector.validation.required'),
                isHide: (!this.showSector.get('primary') || ['PU', 'VA', 'CE', 'VENU'].includes(industry)),
            },
            {
                type: 'select',
                name: 'sector-secondary',
                path: ['additionalTaxonomies', this.vocabularyId, 'termId'],
                label: industry === 'CE'
                    ? i18n.t(`views.survey.wizard.${industry}.stage.1.event.sectors.level2.${product.productType}`)
                    : i18n.t(`views.survey.wizard.${industry}.stage.1.event.sectors.level2`),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                value: this.sectorDetails.get('secondary'),
                options: this.sectorOptions.get('secondary'),
                isMandatory: true,
                errorMessage: i18n.t('views.product.wizard.EV.form.sector.validation.required'),
                isHide: (!this.showSector.get('secondary') || ['PU', 'VA', 'CE', 'VENU'].includes(industry)),
            },
            {
                type: 'select',
                name: 'status',
                label: i18n.t('status'),
                placeholder: i18n.t('form.select.placeholder', 'Select here'),
                defaultValue: product.status,
                options: this.statuses,
                isMandatory: true,
                errorMessage: i18n.t('product.form.error.status'),
                isHide: !(appStore.isExploriClient() || appStore.isSuperUser()) || industry === 'VENU',
            },
            {
                type: 'checkbox',
                label: i18n.t('product.form.isEventFree'),
                name: 'isEventFree',
                defaultChecked: product.isEventFree,
                isHide: !(['CO', 'VI'].includes(product.productType)),
            },
            {
                type: 'checkbox',
                path: ['privilegedFields', 'isSalesIntelligenceEnabled'],
                label: i18n.t('client.form.flags.isSalesIntelligenceEnabled'),
                name: 'privilegedFields-isSalesIntelligenceEnabled',
                defaultChecked: product.privilegedFields.isSalesIntelligenceEnabled,
                isHide: !(appStore.isExploriAdmin() && appStore.userData.flags.isSalesIntelligenceEnabled),
            },
            ...this.defineCustomerCategoryFields(),
        ]
    }

    resetFormState = () => {
        this.formFields = []
    }
}

export default ProductEditStore
